import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class CourierInfoService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }

  saveCourierInfo(courierInfo: any) {
    return this.dataService.post('/api/CourierInfo/SaveCourierInfo', courierInfo);
  };
  getCourierInfo(applicationId: number) {
    return this.dataService.getRecord('/api/CourierInfo/getCourierDetails/' + applicationId);
  }
  getCourierList() {
    return this.dataService.getRecord('/api/CourierInfo/getCourierList');
  }
  getRefrenceNumber(applicationId: number) {
    return this.dataService.getRecord('/api/User/getRefrenceNumber/' + applicationId);
  }
  CourierShoppingProdcts(courierInfo: any) {
    return this.dataService.post('/api/CourierInfo/CourierShoppingProdcts', courierInfo);
  }
  SkyNetSaveCourierInf(appId: any) {
    return this.dataService.getRecord('/api/LTE/SkyNetSaveCourierInfo/'+ appId);
  }
  
}
